// @spec SUP-STR-027
import { createFileRoute } from '@tanstack/react-router';

import { CreateAccountPage } from '@/features/portal/auth';

export const Route = createFileRoute('/portal/auth/create-account/$token')({
  component: CreateAccountRoute,
});

/**
 * Portal create account route.
 *
 * This is a PUBLIC page that allows supplier contacts to create
 * a portal account using a magic link token.
 */
function CreateAccountRoute() {
  const { token } = Route.useParams();

  return <CreateAccountPage token={token} />;
}
